export default "__VITE_ASSET__Bk368_Jg__"